import Axios from "axios";
import QueryOptions from "../sal-ui/QueryOptions";
import PagedResult from "./PagedResult";
import AiReportSummarizer from "../domain/AiReportSummarizer";
import {SupportedModel} from "../domain/AiExtractor";

class AiReportSummarizerService {

    readonly basePath = "/ai-report-summarizers";

    public add(aiReportSummarizer: AiReportSummarizer): Promise<string> {
        return Axios.post(`${this.basePath}`, aiReportSummarizer).then(value => value.data.id);
    }

    public update(id: string, aiReportSummarizer: AiReportSummarizer): Promise<void> {
        return Axios.put(`${this.basePath}/${id}`, aiReportSummarizer);
    }

    public get(id: string): Promise<AiReportSummarizer> {
        return Axios.get(`${this.basePath}/${id}`)
            .then(value => AiReportSummarizer.fromPOJO(value.data));
    }

    public delete(aiReportSummarizer: AiReportSummarizer): Promise<void> {
        return Axios.delete(`${this.basePath}/${aiReportSummarizer.id}`);
    }

    public getList(queryOptions: QueryOptions): Promise<PagedResult<AiReportSummarizer>> {
        return Axios.get(`${this.basePath}?${queryOptions.toQueryParams()}`)
            .then(value => new PagedResult(
                value.data.total,
                value.data.data.map((objectJson: object) => AiReportSummarizer.fromPOJO(objectJson))
            ));
    }

    public getSupportedModels(): Promise<Record<string, { models: SupportedModel[] }>> {
        return Axios.get(`${this.basePath}/supported-models`)
            .then(value => value.data);
    }
}

export default AiReportSummarizerService;
